<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <form @submit.prevent="saveTranslations">
          <card>
            <template slot="header">
              <h3 class="card-title">Translations</h3>
              <h4 class="">Sections</h4>
              <div class="subsection-switch-container">
                <p class="category">Group by subsections</p>
                <base-switch
                  v-model="groupBySubsections"
                  type="info"
                  on-text="ON"
                  off-text="OFF"
                ></base-switch>
              </div>
            </template>
            <tabs ref="tab-sections" type="info" square>
              <tab-pane :id="sectionName" :label="formatForTitle(sectionName)" v-for="(section, sectionName) in translations" :key="sectionName">
                <div v-if="groupBySubsections">
                  <h5>Subsections</h5>
                  <h6 v-if="!getSubSections(section)">No subsections found.</h6>
                  <tabs v-if="getSubSections(section)" type="success" square>
                    <tab-pane :id="subSectionName" :label="formatForTitle(subSectionName)" v-for="(subSection, subSectionName) in getSubSections(section)" :key="'sub_' + subSectionName">
                      <table width="100%">
                        <thead>
                        <th v-for="language in languages" :key="language.language">
                  <span>
                     <flag :iso="language.flag" v-bind:squared=false></flag>
                          {{language.languageName}}
                 </span>
                        </th>
                        </thead>
                        <tbody>
                        <tr v-for="(subSectionCode, subSectionCodeName) in subSection" :key="'subcode_' + subSectionCodeName">
                          <td v-for="language in languages" :key="'subcode_' + language.language">
                            <div>
                              <label>{{subSectionCodeName}}</label>
                            </div>
                            <textarea v-model="translations[sectionName][subSectionCodeName][language.language]" class="lang-row"></textarea>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </tab-pane>
                  </tabs>
                </div>


                <table v-if="!groupBySubsections" width="100%">
                  <thead>
                  <th v-for="language in languages" :key="'normal_' + language.language">
                  <span>
                     <flag :iso="language.flag" v-bind:squared=false></flag>
                          {{language.languageName}}
                 </span>
                  </th>
                  </thead>
                  <tbody>
                  <tr v-for="(sectionCode, sectionCodeName) in section" :key="'normal_' + sectionCodeName">
                    <td v-for="language in languages" :key="'normalsub_' + language.language">
                      <div>
                        <label>{{sectionCodeName}}</label>
                      </div>
                      <textarea v-model="translations[sectionName][sectionCodeName][language.language]" class="lang-row"></textarea>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </tab-pane>
            </tabs>
            <template slot="footer">
              <base-button type="primary" native-type="submit" size="lg" class="btn-fill">
                Save
              </base-button>
            </template>
          </card>
        </form>
      </div>

    </div>
  </div>
</template>
<script>
  import {TabPane, Tabs, BaseSwitch} from 'src/components';
  import {LocalizationService} from '@/services';

  export default {
    components: {
      TabPane,
      Tabs,
      BaseSwitch
    },
    data() {
      return {
        groupBySubsections: false,
        translations: {},
        languages: {},
        activeSection: '',
        model: {
          translations: ''
        }
      }
    },
    methods: {
      async saveTranslations() {
        var activeTabSection = this.$refs['tab-sections'].activeTabId;

        let loader = this.$loading.show();

        var translationsData = {};
        translationsData[activeTabSection] = this.translations[activeTabSection];

        await LocalizationService.updateTranslations({translations: translationsData});
        await LocalizationService.init();

        loader.hide();
      },
      formatForTitle(string) {
        var title = [];
        var words = string.split('_');
        for (let i = 0; i < words.length; i++) {
          title.push(this._.upperFirst(words[i]));
        }
        return title.join(' ');
      },
      getSubSections(section) {
        let subSectionCodes = {};

        Object.keys(section).forEach(function (sectionCode, index) {
          let sectionCodeParts = sectionCode.split('__');
          if (sectionCodeParts.length > 1) {
            let subSectionCodeParent = sectionCodeParts[0];

            if (!subSectionCodes[subSectionCodeParent]) {
              subSectionCodes[subSectionCodeParent] = {};
            }

            if (!subSectionCodes[subSectionCodeParent][sectionCode]) {
              subSectionCodes[subSectionCodeParent][sectionCode] = {};
            }

            subSectionCodes[subSectionCodeParent][sectionCode] = section[sectionCode];

          }
        });

        return Object.keys(subSectionCodes).length ? subSectionCodes : false;
      },
      notifyAboutSaving(verticalAlign, horizontalAlign) {
        this.$notify({
          message:
            'Please note that when you click SAVE, it will only save the current section you are in.',
          timeout: 5000,
          icon: 'tim-icons icon-bell-55',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type: 'info'
        });
      }
    },
    mounted() {
      this.notifyAboutSaving('top', 'center')
    },
    async beforeCreate() {
      let loader = this.$loading.show();
      await LocalizationService.getFormattedTranslations().then((response) => {
        this.translations = response.data;
      }).catch((error) => {

      })

      await LocalizationService.getLanguages().then((response) => {
        this.languages = response.data;
      }).catch((error) => {

      })

      loader.hide();
    }
  };
</script>
<style lang="scss" scoped>
  .subsection-switch-container {
    text-align: right;
    float: right;
    position: absolute;
    top: 2rem;
    right: 2rem;
  }

  textarea.lang-row {
    resize: both;
    width: 95%
  }
</style>
